






















































import { ElTable } from "element-ui/types/table";
import { ExpressionFunctionKinds, ExpressionKinds, ExpressionOperatorKinds, ExpressionReferenceKinds, ICalculationExpressionContent, ICalculationExpressionObjectReference, IDateCalculateItem } from "../../../../../../../documaker/domain/format/objects";
import { Component, Emit, Mixins, Prop, Watch } from "vue-property-decorator";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { OptionDropDownSelector, NumberInput } from "../../../../../../../base/components/system";

@Component({
  components: {
    NumberInput,
    OptionDropDownSelector,
  },
})
export default class CalculationExpressionSelector extends Mixins() {
  @Prop({ default: false })
  shouldShowIndex: boolean;

  @Prop({ default: false })
  shouldShowSettings: boolean;

  @Prop({ default: () => [] as ICalculationExpressionContent[] })
  items: ICalculationExpressionContent[];

  $refs!: {
    table: ElTable,
  };

  get openBracketsOption(): StandardOption<number>[] {
    const options = [] as StandardOption<number>[];
    return options.concat(new StandardOption<number>("", 0))
      .concat(new StandardOption<number>("(", 1))
      .concat(new StandardOption<number>("((", 2))
      .concat(new StandardOption<number>("(((", 3));
  }

  get closeBracketsOption(): StandardOption<number>[] {
    const options = [] as StandardOption<number>[];
    return options.concat(new StandardOption<number>("", 0))
      .concat(new StandardOption<number>(")", 1))
      .concat(new StandardOption<number>("))", 2))
      .concat(new StandardOption<number>(")))", 3));
  }

  get operatorOption(): StandardOption<ExpressionOperatorKinds>[] {
    const options = [] as StandardOption<ExpressionOperatorKinds>[];
    return options.concat(new StandardOption<ExpressionOperatorKinds>("+", ExpressionOperatorKinds.Add))
      .concat(new StandardOption<ExpressionOperatorKinds>("-", ExpressionOperatorKinds.Subtract))
      .concat(new StandardOption<ExpressionOperatorKinds>("×", ExpressionOperatorKinds.Multiply))
      .concat(new StandardOption<ExpressionOperatorKinds>("÷", ExpressionOperatorKinds.Divide))
      .concat(new StandardOption<ExpressionOperatorKinds>("累乗", ExpressionOperatorKinds.Power))
      .concat(new StandardOption<ExpressionOperatorKinds>("√", ExpressionOperatorKinds.Root));


  }

  toKindName(row: ICalculationExpressionContent): string {
    switch (row.kind) {
      case ExpressionReferenceKinds.Object:
        return this.getObjectKindName((row.reference as ICalculationExpressionObjectReference));
      case ExpressionReferenceKinds.Fixed: return "固定数値";
      case ExpressionReferenceKinds.Function: return "関数";
    }
  }

  private getObjectKindName(reference: ICalculationExpressionObjectReference): string {
    switch (reference.type) {
      case "tag":
      case "text":
      case "script":
      case "scriptlink":
        return "テキスト";
      case "check": return "チェック";
      case "circleselect": return "円選択";
      case "combo": return "リスト";
      case "roll": return "クリック";
      case "calculate": return this.getCalculateKindName(reference.expressionKind);
    }
  }

  private getCalculateKindName(kind: ExpressionKinds): string {
    switch (kind) {
      case ExpressionKinds.Calculation: return "計算";
      case ExpressionKinds.Conditional: return "条件";
      case ExpressionKinds.DateDuration: return "期間日数";
      case ExpressionKinds.TimeSpan: return "経過時間";
    }
  }

  correct(value: number): number {
    return isNaN(value) ? null : Math.floor(value);
  }

  toName(row: ICalculationExpressionContent): string {
    switch (row.kind) {
      case ExpressionReferenceKinds.Object: return row.name;
      case ExpressionReferenceKinds.Fixed: return (row.reference as number).toString();
      case ExpressionReferenceKinds.Function:
        return ((row.reference as ExpressionFunctionKinds) === ExpressionFunctionKinds.Root)
          ? "√" : "LN";
    }
  }

  toCategory(row: ICalculationExpressionContent): string {
    return (row.kind === ExpressionReferenceKinds.Object)
      ? (row.reference as ICalculationExpressionObjectReference).subKey
      : "";
  }

  toId(row: ICalculationExpressionContent): string {
    return (row.kind === ExpressionReferenceKinds.Object)
      ? (row.reference as ICalculationExpressionObjectReference).id
        ? (row.reference as ICalculationExpressionObjectReference).id.toString()
        : ""
      : "";
  }

  isObject(row: ICalculationExpressionContent): boolean {
    return (row.kind === ExpressionReferenceKinds.Object);
  }

  isFunction(row: ICalculationExpressionContent): boolean {
    return (row.kind === ExpressionReferenceKinds.Function);
  }

  @Watch("items")
  onItemsUpdated(newValue: ICalculationExpressionContent[], oldValue: ICalculationExpressionContent[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IDateCalculateItem[]): void {}
}
